import { makeAuthenticatedCall, makeCall } from '../commons/routes';

const INVOICING_REST_API_BASE_PATH = `${process.env.PUBLIC_URL}/api/invoicing/consultants`;

export const validateInvoiceLink = (url, callback) =>
    makeCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/validate`,
        'POST',
        undefined,
        undefined,
        (urlStatusDetails) => callback(urlStatusDetails)
    );

export const authenticateInvoiceLink = (url, payload, setAuth) =>
    makeCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/authenticate`,
        'POST',
        payload
    ).then((res) => {
        setAuth({
            isAuthenticated: true,
            token: `Bearer ${res.data.token}`,
        });
    });

export const reportIssueWithInvoicing = (url, payload) =>
    makeCall(`${INVOICING_REST_API_BASE_PATH}/${url}/issue`, 'POST', payload);

/** api calls below this point requires authentication */
export const sessionExpiryCheck = (url, authContext) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/sessionExpiryCheck`,
        'GET',
        undefined,
        authContext,
        null
    );

export const fetchInvoiceData = (url, authContext, callback) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/invoiceDetails`,
        'GET',
        undefined,
        authContext,
        callback
    );

export function submitInvoiceDetails(url, payload, authContext) {
    return makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/invoiceDetails`,
        'POST',
        payload,
        authContext
    );
}

export const fetchInvoiceTrackingDetails = (url, authContext, callback) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/trackInvoiceDetails`,
        'GET',
        undefined,
        authContext,
        callback
    );

export const logInvoicingUserAgentInfo = (url, payload, authContext) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/userAgent`,
        'POST',
        payload,
        authContext
    );

// APIs for draft functionality for invoicing
export const fetchDraft = (url, authContext, callback) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/draft`,
        'GET',
        undefined,
        authContext,
        callback
    );

export const saveInvoiceDraft = (url, payload, authContext, callback) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/draft`,
        'PUT',
        payload,
        authContext,
        callback
    );

// APIs for Tax Document Digital signature related workflow for invoicing
export const getInvoiceTaxDocumentDigitalSignatureContract = (
    url,
    authContext
) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/digitalSignature/contract`,
        'GET',
        undefined,
        authContext
    );

export const createInvoiceTaxDocumentDigitalSignatureContract = (
    url,
    authContext
) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/digitalSignature/contract`,
        'POST',
        undefined,
        authContext
    );

export const getInvoiceTaxDocumentDigitalSignatureSigningUrl = (
    url,
    authContext
) =>
    makeAuthenticatedCall(
        `${INVOICING_REST_API_BASE_PATH}/${url}/digitalSignature/contract/signingUrl`,
        'GET',
        undefined,
        authContext
    );
